import { queryClient } from '../components/queryClient';
import { Permit } from '../interfaces';

const key = 'roadworks';

/**
 *
 * @param event Event to put into cache
 *
 * @description This function is used to put an event into the query cache,
 * and to invalidate the query, so that the next time the event is requested (via hook)
 * it will be fetched from the server BUT before the server responds, the cached data
 * will be displayed (instantenously) so that the app will feel snappier.
 */
export const setRoadworkQueryCache = (data: Permit) => {
  // Put data (or partial data) into cache
  queryClient.setQueryData([key, data.id], data);

  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries([key, data.id]);
};

export const invalidateRoadworkPermits = async () => {
  queryClient.invalidateQueries({ queryKey: [key], refetchType: 'all' });
};

export const setPermitPreview = (data: Permit | null) => {
  queryClient.setQueryData([key, 'preview'], data);
};
